import { Box, Grid, Collapse, Card } from "@mui/material";
import ActiveFilters from "../../../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  pickers,
}) => {
  // Find picker name by ID
  const getPickerName = (pickerId) => {
    if (!pickerId) return "";
    const picker = pickers.find((p) => p.picker_id === pickerId);
    return picker ? picker.picker_name : pickerId;
  };

  const activeFilterDefinitions = [
    {
      type: "standard",
      id: "picker_id",
      label: "Picker",
      value: getPickerName(submittedData.picker_id),
    },
    {
      type: "dateRange",
      id: "date",
      label: "Date Range",
      startValue: submittedData.start_date,
      endValue: submittedData.end_date,
      startField: "start_date",
      endField: "end_date",
    },
  ];

  const handleRemoveDateRange = (field) => {
    handleRemove(field);
  };

  return (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <Collapse in={filterOpen}>
        <Card>
          <Box p={4}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
              pickers={pickers}
            />
          </Box>
        </Card>
      </Collapse>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveDateRange={handleRemoveDateRange}
        onRemoveFilter={handleRemove}
      />
    </Grid>
  );
};

export default Filter;
